const PuppyInfoOk = {
  SET_PUPPY_INFO_OK: 'SET_PUPPY_INFO_OK',
};

export default PuppyInfoOk;
